import { EraEcotoxImportPopupApiService } from './era-ecotox-import-popup.api.service';
import { Injectable } from '@angular/core';
import { lastValueFrom, take } from 'rxjs';
import { EcotoxEndpointFlatValues } from './era-ecotox-import-popup.interface';
import { Constants } from 'src/app/shared/utils/constants';
import { ImportDataSet } from 'src/app/shared/models/echo/import-data-set';

@Injectable({
  providedIn: 'root'
})
export class EraEcotoxImportPopupLogicService {

  constructor(private readonly apiService: EraEcotoxImportPopupApiService) { }

  public async getEcotoxEndpointFlatValues(datasetToImportPk: number, geography: string): Promise<any> {
    const source$ = this.apiService.getEcotoxEndpointFlatValues(datasetToImportPk, geography).pipe(take(1));
    return await lastValueFrom(source$);
  }

  public filterEndpoints(
    endpoints: EcotoxEndpointFlatValues[],
    taxonGroup: string | undefined,
    datasetToImport: ImportDataSet,
    metabolitePks: number[]
  ): EcotoxEndpointFlatValues[] {
    return endpoints.filter(endpoint => {
      if (endpoint.taxonGroup !== taxonGroup) return false;

      switch (datasetToImport.substanceType) {
        case Constants.SUBSTANCE_TYPES.FORMULATION:
          return datasetToImport.formulationPk != null &&
            endpoint.formulationPk === datasetToImport.formulationPk;
        case Constants.SUBSTANCE_TYPES.ACTIVE:
          return datasetToImport.moleculePk != null &&
            endpoint.moleculePk === datasetToImport.moleculePk;
        case Constants.SUBSTANCE_TYPES.METABOLITE:
          return endpoint.metabolitePk != null &&
            (endpoint.metabolitePk === datasetToImport.metabolitePk || metabolitePks.includes(endpoint.metabolitePk));
        default:
          return false;
      }
    });
  }

}
